module.exports = __webpack_public_path__ + "7b656cf0.svg";